import { render, staticRenderFns } from "./TagsItem.vue?vue&type=template&id=19ed99cb"
import script from "./TagsItem.vue?vue&type=script&lang=js"
export * from "./TagsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports